import { useAreaFromSlug } from 'hooks/useAreaFromSlug'
import {
  Contact,
  GetAdvice,
  OurApproach,
  OurApproachSolutionProcess,
} from 'pages/legal-fields/components'
import { useParams } from 'react-router-dom'
import { Banner, LatestMedia } from './components'

const LegalSubField = () => {
  const params = useParams()
  const area = useAreaFromSlug(params?.area)

  return (
    <>
      <Banner title={area?.master_term} imgSrc={area?.banner_image} />
      <LatestMedia subArea={area?.master_term} />
      <OurApproach />
      <OurApproachSolutionProcess />
      <GetAdvice id={area?.id} idName='sub_area_id' />
      <Contact />
    </>
  )
}

export default LegalSubField
